
import React from "react";
import { format } from "date-fns";
import { it } from "date-fns/locale";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowLeft, ArrowRight, CalendarIcon, Settings } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

export interface CalendarHeaderProps {
  startDate: Date;
  currentDate: Date;
  activeTab: string;
  onTabChange: (value: string) => void;
  onPrevWeek: () => void;
  onNextWeek: () => void;
  onPrevDay: () => void;
  onNextDay: () => void;
  isClientView?: boolean;
  onOpenSettings?: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  startDate,
  currentDate,
  activeTab,
  onTabChange,
  onPrevWeek,
  onNextWeek,
  onPrevDay,
  onNextDay,
  isClientView = false,
  onOpenSettings
}) => {
  const isMobile = useIsMobile();
  const formattedDate = format(currentDate, "MMMM yyyy", {
    locale: it
  });
  const formattedDay = format(currentDate, "EEEE d", {
    locale: it
  });
  
  const handleTabChange = (value: string) => {
    console.log("CalendarHeader: cambio tab a", value);
    onTabChange(value);
  };
  
  return <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0 w-full">
      <div className="flex items-center gap-2">
        <CalendarIcon className="h-5 w-5 text-primary" />
        <h1 className="text-xl sm:text-2xl font-semibold">
          Calendario - <span className="text-muted-foreground">{formattedDay} {format(currentDate, "yyyy")}</span>
        </h1>
      </div>
      
      <div className="flex items-center gap-2">
        <Tabs value={activeTab} onValueChange={handleTabChange} className="mr-2">
          <TabsList>
            <TabsTrigger value="week">Settimana</TabsTrigger>
            <TabsTrigger value="day">Giorno</TabsTrigger>
          </TabsList>
        </Tabs>
        
        {activeTab === "week" ? (
          <div className="flex gap-1">
            <Button variant="outline" size="icon" onClick={onPrevWeek}>
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <Button variant="outline" size="icon" onClick={onNextWeek}>
              <ArrowRight className="h-4 w-4" />
            </Button>
          </div>
        ) : (
          <div className="flex gap-1">
            <Button variant="outline" size="icon" onClick={onPrevDay}>
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <Button variant="outline" size="icon" onClick={onNextDay}>
              <ArrowRight className="h-4 w-4" />
            </Button>
          </div>
        )}
        
        {!isClientView && onOpenSettings && (
          <Button
            variant="outline"
            size="icon"
            onClick={onOpenSettings}
            className="ml-2"
          >
            <Settings className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>;
};

export default CalendarHeader;
